var BibadoBundle = {
  calculate(rows, variants) {
    const quantities = new Map();
    for (const row of rows) {
      const n = Math.max(0, Math.floor(Number(row.qty) || 0));
      quantities.set(String(row.id), (quantities.get(String(row.id)) || 0) + n);
    }
    const lines = [];
    for (const [id, requested] of quantities) {
      const variant = variants.find(v => String(v.id) === id);
      if (!variant || !variant.available) continue;
      const qty = Math.min(requested, Math.max(0, Number(variant.max) || 0));
      if (qty > 0) lines.push({id, qty, price: Number(variant.price), original: Math.max(Number(variant.price),Number(variant.compareAtPrice)||0)});
    }
    const count = lines.reduce((n,l) => n+l.qty,0);
    const subtotal = lines.reduce((n,l) => n+l.qty*l.price,0);
    const total = lines.reduce((n,l) => n+(count>=2?l.qty*Math.round(l.price*92/100):l.qty*l.price),0);
    const original = lines.reduce((n,l) => n+l.qty*l.original,0);
    return {lines,count,subtotal,total,original,saleSaving:original-subtotal,saving:subtotal-total,totalSaving:original-total,eligible:count>=2};
  }
};

